module.exports = __webpack_public_path__ + "2c64dfc3b5883f5d0b5ff209d4de8f08.jpg";